import { render, staticRenderFns } from "./m16-treelogy.vue?vue&type=template&id=85d10cf8&"
import script from "./m16-treelogy.vue?vue&type=script&lang=js&"
export * from "./m16-treelogy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports